import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./AwsBanner.css";

const STORAGE_KEY = "aws-banner-dismissed";

export default function AwsBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      setVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setVisible(false);
    localStorage.setItem(STORAGE_KEY, "1");
  };

  if (!visible) return null;

  return (
    <div className="aws-banner" role="banner">
      <div className="aws-banner-inner">
        <span className="aws-banner-badge">AWS Partner</span>
        <span className="aws-banner-text">
          Official AWS Partner — Save 20-37% on Your AWS Bill
        </span>
        <Link to="/aws-partner" className="aws-banner-link">
          Learn More
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </Link>
      </div>
      <button
        className="aws-banner-close"
        onClick={handleDismiss}
        aria-label="Dismiss banner"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
}
